export default __webpack_public_path__ + "static/13-f22e045931fa0fffb59ce5d295669627.png";